export default __webpack_public_path__ + "static/SR USA - Origen - Declaración-a7c3121de9a83961d1f4e983073e6ce7.pdf";